<template>
  <q-page padding>
    <div class="flex-center row">
      <q-card class="col-4">
        <q-card-section>
          {{cart.name}}
        </q-card-section>
        <q-card-section>
          <q-btn color="primary" @click="pay">Make Payment of ${{totalCost}}</q-btn>
        </q-card-section>
      </q-card>
    </div>
  </q-page>
</template>

<script>
import StripeDialog from '../components/StripeDialog'
import gql from 'graphql-tag'

export default {
  name: 'PageThanksForRegistering',
  apollo: {
    validateCart () {
      return {
        query: gql`query validateCart ($cartId: ID!) {
            validateCart (id: $cartId)
        }`,
        variables () {
          return {
            cartId: this.cartId
          }
        },
        skip: () => !this.cartId,
        fetchPolicy: 'no-cache',
        async result (result) {
          // Clear all warnings
          if (result.data.validateCart === true) this.cartErrors = []
        },
        error (error) {
          // Error is stored in a rather confusing structure.  See if future apollo updates break this... :(
          const parentCartValidationError = error.graphQLErrors?.find(v => v.extensions?.exception?.name === 'CartValidationErrors')?.extensions?.exception || {}
          this.cartErrors = parentCartValidationError?.errors || []
        }
      }
    },
    cart () {
      return {
        query: gql`
          query cart ($id: ID!) {
            cart(id: $id) {
              id,
              name,
              notes,
              items {
                id,
                skuId,
                qty,
                sku {
                    id,
                    stock,
                    retailPrice,
                    attributes,
                    options,
                    product {
                        id,
                        name,
                        images {
                          url
                          name
                        },
                        attributes,
                        urlSlug,
                    }
                }
              }
            }
          }
        `,
        variables () {
          return {
            id: this.cartId
          }
        },
        async result ({ data }) {
          try {
            await this.$apollo.queries.validateCart.refetch()
          } catch (ex) {
          }
          return data.cart
        },
        skip: () => !this.cartId,
        error (error) {
          if (error.message === `GraphQL error: Cart with id ${this.cartId} does not exist.`) {
            // createNewActiveCart
          }
        }
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    currentAccount () {
      return this.$store.state.auth.currentAccount
    },
    cartId () {
      return this.currentAccount?.activeRetailCartId
    },
    totalCost () {
      return (this.cart?.items || []).reduce((p, c, i) => p + ((c.sku?.retailPrice || 0) * c.qty), 0)
    }
  },
  methods: {
    pay () {
      this.$q.dialog({
        component: StripeDialog,
        cartId: this.cartId,
        totalCost: this.totalCost,
        apollo: this.$apollo
      }).onOk(async ({ orderId }) => {
        // eslint-disable-next-line no-undef
        analytics.track('Placed Order', {
          orderId,
          value: this.totalCost,
          cart: this.cart
        })

        await this.$store.dispatch('auth/fetchCurrentAccount')
        await this.$store.dispatch('cart/fetchActiveCart', 'retail')
        this.$router.push(`/retail/place-order/${orderId}`)
      }).onCancel(() => {

      })
    }
  }
}
</script>
